import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import { useTenant } from "./context/TenantContext";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ChatLayout from "./pages/ChatLayout";
import TenantSelector from "./pages/TenantSelector";
import NotificationBell from "./components/NotificationBell";

function App() {
  const { user, loading } = useAuth();
  const { activeTenant, showSwitcher, personalMode, loading: tenantLoading } = useTenant();

  if (loading || (user && tenantLoading)) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner" />
        <p>Loading nextversion AI...</p>
      </div>
    );
  }

  return (
    <>
      <Routes>
        <Route path="/login" element={!user ? <Login /> : <Navigate to="/" />} />
        <Route
          path="/register"
          element={!user ? <Register /> : <Navigate to="/" />}
        />
        <Route
          path="/*"
          element={
            !user
              ? <Navigate to="/login" />
              : showSwitcher
                ? <TenantSelector />
                : (activeTenant || personalMode)
                  ? <ChatLayout />
                  : <TenantSelector />
          }
        />
      </Routes>
      {/* Notification-Bell schwebt über allem; rendert sich selbst nur wenn
          ein aktiver Mandant existiert (im Privat-Modus gibt es keine
          Notifications, weil keine Aufgaben/Workflows). */}
      {user && activeTenant && !showSwitcher && <NotificationBell />}
    </>
  );
}

export default App;
